import '../Styles/Footer.css';
export function MainFooter(){
    return(
        <div className='footerMainDiv'>
            Footer
        </div>
    )
}